/* RESPONSIBLE TEAM: team-inbox-management */
import type IntlService from 'embercom/services/intl';
import type PermissionsModal from 'embercom/services/permissions-modal';
import type AppService from 'embercom/services/app-service';

interface PermissionsService {
  currentAdminCan(permission: string): boolean;
}

interface CheckConversationCreationPermissionParams {
  appService: AppService;
  permissionsService?: PermissionsService;
  permissionsModal: PermissionsModal;
  intl: IntlService;
}

export function checkConversationCreationPermission({
  appService,
  permissionsService,
  permissionsModal,
  intl,
}: CheckConversationCreationPermissionParams): boolean {
  let hasPermission = permissionsService
    ? permissionsService.currentAdminCan('can_manage_conversation_creation')
    : appService.app.currentAdmin?.canManageConversationCreation;

  if (!hasPermission) {
    permissionsModal.showModal({
      permissionsLabel: intl.t('inbox.conversation-header.create-conversation-permission-label'),
    });
    return false;
  }

  return true;
}
